// extracted by mini-css-extract-plugin
module.exports = {"statusesContainer":"statusList_statusesContainer__26k4f","customCollapse":"statusList_customCollapse__1LMoZ"};